<!--
 * @Description: 通知公告详情
 * @Author: PF
 * @Date: 2023-04-11 17:49:57
 * @LastEditors: PF
 * @LastEditTime: 2024-12-09 10:11:42
-->
<template>
  <div>
    <el-dialog class="wp83 hp83" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, true)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-container class="xinwen">
        <el-header style="padding:20px; border: 1px solid #e4e7ed;">
          <div class="card-header">
            <h2>{{ruleForm.bt}}</h2>
            <h4 class="fu-biao-ti">
              <span>发布机构：{{ruleForm.jgmc}}</span>
              <span>发布时间：{{ruleForm.fbsj}}</span>
            </h4>
          </div>
        </el-header>
        <el-main style="padding:20px; border: 1px solid #e4e7ed; border-top: none;overflow: auto;">
          <div class="nei-rong">
            <p style="white-space: pre-wrap; text-indent:0;" v-html="ruleForm.nr"></p>
          </div>
        </el-main>
        <el-footer class="el-dialog__footer">
            <div class="dialog-footer">
              <div></div>
              <div class="footer_but">
                <el-button link type="primary" @click="openFuJian=true;">附件</el-button>
              </div>
            </div>
        </el-footer>
      </el-container>
    </el-dialog>
  </div>
  <fujian v-if="openFuJian" v-model:openDetail="openFuJian" :row="{listFj:ruleForm.listfujian}" />
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow } from '@/api/common.js'
import fujian from '@/components/fujian.vue'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDetail'])
const ruleForm = ref({})
const openFuJian = ref(false)

watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      loadData({
        url: '/api/v2/bangong/tongzhigonggao/chakanshouyetongzhi/' + props.row.id,
        ruleForm,
        loadSuccess: function (res) {
          ruleForm.value.listfujian = res.data.listfujian.map(item => ({ fj: item.fjdz }))
        }
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
<style lang="less" scoped>
:deep(.el-card__header) {
  text-align: center;
}
.fu-biao-ti {
  color: #73767a;
  margin-top: 10px;
  span {
    margin: 0 10px;
  }
}
.nei-rong {
  color: #73767a;
  line-height: 30px;
}
</style>
